let stripePubKey;
const stripeSecretKey = '';
if (process.env.APP_ENV === 'production') {
    stripePubKey = `${process.env.VUE_APP_STRPE_PUBLIC_LIVE_KEY}`;
} else {
    stripePubKey = `${process.env.VUE_APP_STRPE_PUBLIC_TEST_KEY}`;
}

const STRIPE_PUB_KEY = stripePubKey;
const STRIPE_SECRET_KEY = stripeSecretKey;

export {
    STRIPE_PUB_KEY,
    STRIPE_SECRET_KEY
};


// WEBPACK FOOTER //
// ./src/lib/global.js